<footer class="mt-5">
    <div class="container content">
        <div class="col col-left">
            <a routerLink="/">
                <img src="../../../assets/img/logo/256px.png" height="64px" width="64px" alt="Logo Tropik'Art">
            </a>
            <h5 class="fs-primary fw-default uppercase">Tropik'Art</h5>
            <p class="contact">
                <a href="tel:+68987658588">+689 87 65 85 88</a>
                <a href="mailto:peremandch.fr">peremandch.fr</a>
            </p>
        </div>
        <div class="col col-center">
            <p class="fw-bold c-default">Pages</p>
            <ul>
                <li><a routerLink="/">Accueil</a></li>
                <li><a routerLink="/about">À propos</a></li>
                <li><a routerLink="/gallery/image">Galerie d'image</a></li>
                <li><a routerLink="/gallery/video">Nos vidéos</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
        <div class="col col-center">
            <p class="fw-bold c-default">Mes informations</p>
            <ul>
                <li><a routerLink="/account">Mon compte</a></li>
                <li><a routerLink="/legal">Mention légale</a></li>
            </ul>
        </div>
    </div>
    <div class="bottom p-3">
        <p class="small">Copyright 2025 © Ariitea - Tous droits réservés</p>
    </div>
</footer>